<template>
  <BLayoutExpansionTableAsync
    :value="list"
    v-bind="$attrs"
    :loading="isLoading"
    :readonly="readonly"
    :pagination="pagination"
    title="Критерии заданий"
    type-table="collector-criteria"
    name="criteria"
    return-object
    @change:pagination="onChangePagination"
    @action:download="onDownload"
  >
    <template #top>
      <BListFilter
        v-model="searchForm"
        label="Поиск по варианту"
        :skeleton="isLoading"
        dense
        @change="onChangeSearch"
      />
    </template>
  </BLayoutExpansionTableAsync>
</template>

<script>
import { downloadLinkByGet } from '@/helpers/downloadBlob'
import BLayoutExpansionTableAsync from '@/components/layouts/BLayoutExpansionTableAsync.vue'
import { DEFAULT_PER_PAGE } from '@/helpers/enums/params'
import { lkParticipantPermissions as Permissions } from '@/helpers/enums/permission-models'
import { KimCriteriaApi } from '@/api/resources'
import BListFilter from '@/components/forms/BListFilter.vue'

const DEFAULT_PARAMS = {
  page: 1,
  per_page: DEFAULT_PER_PAGE,
  count: 0,
}

export default {
  name: 'BasePublicationsCriteriaExpansionTable',
  components: { BLayoutExpansionTableAsync, BListFilter },
  props: {
    publication: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    list: [],
    searchForm: {
      search: null,
    },
    pagination: { ...DEFAULT_PARAMS },
  }),
  computed: {
    readonly() {
      return !this.$access(Permissions.edit)
    },
  },
  methods: {
    asyncData() {
      return this.onGetData()
    },
    async onGetData(params = {}) {
      const api = new KimCriteriaApi()
      const payload = {
        ...this.pagination,
        ...params,
        publication_id: this.publication.publication_id,
      }

      if (this.searchForm.search && !Number.isNaN(+this.searchForm.search)) {
        payload.original_variant = this.searchForm.search
      }

      this.isLoading = true
      try {
        const result = await api.getAll(payload)
        this.list = result.data
        this.pagination.count = result.meta.count
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
      }
    },
    onChangePagination(options) {
      this.pagination.page = options.page || DEFAULT_PARAMS.page
      this.pagination.per_page = options.per_page || DEFAULT_PARAMS.per_page

      return this.onGetData()
    },
    onChangeSearch() {
      this.pagination.page = DEFAULT_PARAMS.page
      return this.onGetData()
    },
    onDownload({ sha1_sum: sha1Sum }) {
      if (!sha1Sum) return

      try {
        const path = `${process.env.VUE_APP_COLLECTOR_API_URL}/api/v1/files/${sha1Sum}/download`
        downloadLinkByGet(
          path,
          false,
          { isNewTab: false },
          { headers: { 'X-Access-Token': process.env.VUE_APP_COLLECTOR_API_TOKEN } },
        )
      } catch (e) {
        this.$notice.errors(e)
      }
    },
  },
}
</script>
